import React, { useState } from "react";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";

const initialState = { name: "", email: "", message: "" };

export const Contact = (props) => {
  const [{ name, email, message }, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const clearState = () => setForm(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm("service_wkffgxp", "template_789smp8", e.target, "dZFmh3EJTI4ghGn0C")
      .then(
        () => {
          toast.success("Message envoyé avec succès");
          clearState();
          setLoading(false);
        },
        () => {
          toast.error("Échec de l'envoi du message. Veuillez réessayer.");
          setLoading(false);
        }
      );
  };

  return (
    <div id="contact">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container">
        <div className="col-md-7">
          <div className="row">
            <div className="section-title">
              <h2>Contactez-nous</h2>
              <p>
                Remplissez le formulaire ci‑dessous pour nous envoyer un message.
                Nous vous répondrons dès que possible.
              </p>
            </div>
            <form name="sentMessage" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Nom"
                      required
                      value={name}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                      value={email}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows="4"
                  placeholder="Votre message"
                  required
                  value={message}
                  onChange={handleChange}
                  disabled={loading}
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-custom btn-lg"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fa fa-spinner fa-spin" /> Envoi en cours…
                  </>
                ) : (
                  "Envoyer le message"
                )}
              </button>
            </form>
          </div>
        </div>
        <div className="mt-8 col-md-4 col-md-offset-1 contact-info">
          <div className="contact-item">
            <h3>Informations de contact</h3>
            <p>
              <span>
                <i className="fa fa-map-marker"></i> Adresse
              </span>
              2 RUE BARYE, PARIS 75017
            </p>
          </div>
          <div className="contact-item">
            <p>
              <span>
                <i className="fa fa-phone"></i> Téléphone
              </span>{" "}
              0655555555
            </p>
          </div>
          <div className="contact-item">
            <p>
              <span>
                <i className="fa fa-envelope-o"></i> Email
              </span>{" "}
              valerie@destinsdefemmes.com
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className="social">
              <ul>
                <li>
                  <a href={props.data?.facebook || "/"}>
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data?.instagram || "/"}>
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data?.youtube || "/"}>
                    <i className="fa fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
